import { createFileRoute } from '@tanstack/react-router'
import { BarChart3 } from 'lucide-react'

import { LotStatsPage } from '@/components/warehouse/lot-stats-page'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/warehouse-sales/stats',
)({
    component: () => (
        <LotStatsPage
            kind="product"
            title={m.nav_sales_stats()}
            subtitle={m.lot_stats_subtitle()}
            permission="warehouse_sales.read"
            icon={BarChart3}
            groupDimLabel={m.lot_stats_dim_product()}
        />
    ),
})
